<template>
  <div>
	  <div v-if="isShow" class="box" style="">
	  		<h6>{{myTitle}}</h6>
	  		<p>{{myContent}}</p>
	  		<div><span v-if="cancelOff">取消</span><span @click="hideDialog">确认</span></div>
	  		
		
	  </div>
	  <div class="mask" :style="{height: getHeight()}"  v-if="isShow"></div>
	</div>
</template>

<script>

export default {
  components: {
   

  },
  name: 'dialog',
  props:{
  	cancelOff:{
  	   type:Boolean,
       default:false
    },
    isShow:{
  	   type:Boolean,
       default:false
    },
    myTitle:{
    	type:String,
    	default:""
    },
    myContent:{
    	type:String,
    	default:""
    },

  },
  data () {
    return {
    
    	
    }
  },
  methods:{
   	getHeight(){
		var iH =  Math.max(document.documentElement.clientHeight,document.body.scrollHeight,document.body.offsetHeight);
   		 this.iHeight = iH + 'px';
   		 return (iH+'px')
   	},
   	hideDialog(){
	   	//this.isShow = false

	   	 this.$emit('on-close')
   	}
  }
  
 
}
</script>


<style scoped>
.box{position: fixed;width: 6rem;z-index:100;top: 0;left: 0.75rem;background: #fff;font-size: 0.3rem;top:40%;}
.box h6{font-size: 0.4rem;width: 100%;text-align: center;padding-top: 0.4rem}
.box p{font-size: 0.36rem;margin-top: 0.2rem;padding: 0.2rem;text-align: center;line-height: 0.6rem}
.box span{width: 100%;height: 0.8rem;border-top: 1px solid #dedddd;display: block;text-align: center;line-height: 0.8rem;color: blue}
.mask{width: 100%;position: absolute;z-index: 99;background: #000;opacity: 0.6;left: 0;top: 0}


</style>



// WEBPACK FOOTER //
// src/components/base/dialog.vue